export default __webpack_public_path__ + "static/media/loveresume.0caa807d.pdf";